import React, { useCallback } from 'react'
import { Box } from '@mui/material'
import {
  Create,
  SimpleForm,
  SelectInput,
  required,
  NumberInput,
  minValue,
  ReferenceArrayInput,
  SelectArrayInput,
  Toolbar,
  SaveButton,
  FormDataConsumer
} from 'react-admin'
import { PERMISSIONS } from '../../../constants'
import Permission from '../../../components/Permission'
import { PeriodPointType } from '../../../models/periodPointType';
import { useLocation } from 'react-router-dom';
import { PointRule } from '../../../models';

const validateInput = [required()]
const validateNumberInput = [required(), minValue(1)]

export default props => {
  const { state: params } = useLocation();

  const periodChoices = [
    { id: PeriodPointType.weekly, name: 'Semanalmente' },
    { id: PeriodPointType.monthly, name: 'Mensalmente' },
    { id: PeriodPointType.daily, name: 'Dias' },
  ];

  const getInitialValues = useCallback(() => {
    const { ...restParams } = params as { [key: string]: string }
    return PointRule.createPointLimit({ ...restParams });
  }, []);

  const CustomToolbar = () => {
    const enabled = params.id ? true : false;

    return (
      <Toolbar>
        <SaveButton alwaysEnable={enabled} />
      </Toolbar>
    );
  }

  return (
    <Permission permission={PERMISSIONS.POINT_RULES}>
      <Create {...props} title="Nova regra de limite de pontos">
        <SimpleForm defaultValues={getInitialValues()} toolbar={<CustomToolbar />}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
            {/* Linha 1: Posto sozinho, ocupando toda a largura */}
            <ReferenceArrayInput
              source="stationIds"
              reference="stations"
              perPage={null}
              sort={{ field: "name", order: "ASC" }}
              alwaysOn
            >
              <SelectArrayInput
                label="Posto"
                optionText="name"
                sx={{ width: '100%' }}
              />
            </ReferenceArrayInput>
            {/* Linha 2: demais campos, se auto-ajustando para preencher a linha */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
              <SelectInput
                source="period"
                label="Periodo"
                choices={periodChoices}
                validate={validateInput}
                fullWidth={false}
                sx={{ flex: '1 1 200px', minWidth: 200 }}
              />
              <FormDataConsumer>
                {({ formData }) => (
                  formData.period === PeriodPointType.daily &&
                  <NumberInput
                    source='days'
                    label="Quantidade de dias"
                    validate={validateNumberInput}
                    fullWidth={false}
                    sx={{ flex: '1 1 200px', minWidth: 200 }}
                  />
                )}
              </FormDataConsumer>
              <NumberInput
                source='amountPoints'
                label="Quantidade de pontos"
                validate={validateNumberInput}
                fullWidth={false}
                sx={{ flex: '1 1 200px', minWidth: 200 }}
              />
            </Box>
          </Box>
        </SimpleForm>
      </Create>
    </Permission>
  )
}
